import cn from 'classnames'
import type { FC, HTMLAttributes } from 'react'
import styles from './channel-button.module.css'

export interface ChannelButtonProps extends HTMLAttributes<HTMLButtonElement> {
  className?: string
  selected?: boolean
  disabled?: boolean
}

export const ChannelButton: FC<ChannelButtonProps> = props => {
  const { className, selected = false, style, children, ...restProps } = props
  return (
    <button
      type="button"
      className={cn(styles.button, selected && styles['button--selected'], className)}
      style={style}
      {...restProps}
    >
      <span className={styles.contents}>{children}</span>
    </button>
  )
}

export default ChannelButton
